module.exports = __webpack_public_path__ + "img/8..b0c1ff53.jpg";